import { showPageLoader } from '../utils';
const LOYALTY_MANAGEMENT = {};

LOYALTY_MANAGEMENT.init = function () {
  if (window.showLoyaltyManagementOffer) {
    addCallbacksToLoyaltyManagementOfferBox();
  }
};

function addCallbacksToLoyaltyManagementOfferBox() {
  const loyaltyManagementOfferBox = document.getElementById(
    'loyalty-management-offer-box-wrapper'
  );

  if (loyaltyManagementOfferBox) {
    loyaltyManagementOfferBox.onAddToCartSuccess = reloadPage;
    loyaltyManagementOfferBox.onRemoveFromCartSuccess = reloadPage;
  }
}

function reloadPage() {
  showPageLoader();
  window.location.reload();
}

export default LOYALTY_MANAGEMENT;
